import { createAction, props } from '@ngrx/store';
import { NgrxRoute } from './router.interfaces';

export const RouterGo = createAction('[router] Go', props<{ to: NgrxRoute }>());
export const RouterBack = createAction('[router] BACK');
export const RouterForward = createAction('[router] FORWARD');
